import type { ComponentPropsWithoutRef } from 'react'
import { twMerge } from 'tailwind-merge'

export const InputGroup = (props: ComponentPropsWithoutRef<'div'>) => {
  const _className = twMerge('flex flex-col gap-5 lg:w-full lg:flex-row', props.className)

  return <div className={_className}>{props.children}</div>
}
